import { render, staticRenderFns } from "./DualViewSettingDialog.vue?vue&type=template&id=7b07b4e4"
import script from "./DualViewSettingDialog.vue?vue&type=script&lang=js"
export * from "./DualViewSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./DualViewSettingDialog.vue?vue&type=style&index=0&id=7b07b4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports